import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=fbd9a284&scoped=true&"
import script from "./appointment.vue?vue&type=script&lang=js&"
export * from "./appointment.vue?vue&type=script&lang=js&"
import style0 from "./appointment.vue?vue&type=style&index=0&id=fbd9a284&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd9a284",
  null
  
)

export default component.exports